export default {
  SPOTLIGHT: 'spotlight',
  INSURANCE_REPORT: 'insurance_report',
};
